module.exports = __webpack_public_path__ + "static/img/100.27760f10.png";